import React, { useEffect } from "react";

export function LabelWidget(props) {
  const { data, ui, config } = props;
  const widgetId = ui.id;
  
  let contentFromData = data && data.content ? data.content : null;
  let contentFromConfig = config ? config.PredefinedText : null;
  let content = contentFromData || contentFromConfig || "";

  let larger = config ? config.IsHigherImportance : false;
  let smaller = config ? config.IsLowerImportance : false;
  let bold = true;

  useEffect(() => {
    //console.log("LabelWidget data of " + ui.id + ": ", data);
  }, [data]);

  const labelStyle = {
    cursor: "default",
    fontWeight: bold ? "bold" : "normal",
    fontSize: larger ? "larger" : (smaller ? "smaller" : "normal"),
    lineHeight: ui.controlHeight + "em",
    height: "100%"
  };

  return (
    <div style={labelStyle} id={widgetId} >
      {content}
    </div>
  );
}
